import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductMetafield extends HTMLElement {
  originalFallbacks = {};

  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    console.log('[ProductMetafield] connected');
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateMetafield);

    // Store fallbacks for certain refs
    ['description', 'caracteristique', 'conseil-d-entretien'].forEach((ref) => {
      const el = this.querySelector(`[ref="${ref}"]`);
      const content = el?.innerHTML?.trim();
      if (content) {
        this.originalFallbacks[ref] = content;
      }
    });

    // On initial load: hide sasuke blocks with empty <p>
    const sasukeMetafields = closestSection.querySelectorAll('product-metafield.hidden-sasuke');
    sasukeMetafields.forEach((metafield) => {
      const p = metafield.querySelector('p');
      const isEmpty = !p || !p.textContent.trim();
      if (isEmpty) {
        metafield.style.display = 'none';
      }
    });
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateMetafield);
  }

  updateMetafield = (event) => {
    const { newProduct, html } = event.detail.data;

    if (newProduct) {
      this.dataset.productId = newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const refs = [
      'description',
      'caracteristique',
      'origine',
      'composition',
      'longueur',
      'hauteur',
      'profondeur',
      'largeur',
      'diametre',
      'taille_assise',
      'homemade',
      'conseil-d-entretien'
    ];

    const contentMap = {};
    refs.forEach((ref) => {
      const newElement = html.querySelector(`product-metafield [ref="${ref}"]`);
      contentMap[ref] = newElement?.innerHTML?.trim() || '';
    });

    // Fallback: reuse first available content
    const fallbackRefs = ['description',
      'caracteristique',
      'origine',
      'composition',
      'longueur',
      'hauteur',
      'profondeur',
      'largeur',
      'diametre',
      'taille_assise',
      'homemade',
      'conseil-d-entretien'];
    const firstNonEmptyContent = fallbackRefs
      .map(ref => contentMap[ref])
      .find(content => content !== '');

    fallbackRefs.forEach((ref) => {
      if (contentMap[ref] === '' && firstNonEmptyContent) {
        contentMap[ref] = firstNonEmptyContent;
      }
    });

    // Update each block
   refs.forEach((ref) => {
  const newElement = html.querySelector(`product-metafield [ref="${ref}"]`);
  const currentElement = this.querySelector(`[ref="${ref}"]`);
  if (!currentElement) return;

  const wrapper =
    currentElement.closest('accordion-custom') ||
    currentElement.closest('.metafield-block') ||
    currentElement.closest('product-metafield') ||
    currentElement.parentElement;

  const newParagraph = newElement?.querySelector('p');
  const isEmptyP = !newParagraph || !newParagraph.textContent.trim();

  // Fallback only if no <p> and this is one of the 3 fallback refs
  let fallbackContent = '';
  if (
    isEmptyP &&
    ['description',
      'caracteristique',
      'origine',
      'composition',
      'longueur',
      'hauteur',
      'profondeur',
      'largeur',
      'diametre',
      'taille_assise',
      'homemade',
      'conseil-d-entretien'].includes(ref)
  ) {
    fallbackContent = this.originalFallbacks[ref] || '';
  }

  if (isEmptyP && fallbackContent === '') {
    if (wrapper) wrapper.style.display = 'none';
  } else {
    // Use full HTML update only if content exists
    currentElement.innerHTML = newElement?.innerHTML?.trim() || fallbackContent;
    if (wrapper) wrapper.style.removeProperty('display');
  }
});
  };
}

if (!customElements.get('product-metafield')) {
  customElements.define('product-metafield', ProductMetafield);
}

